var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('loading'),_c('main-navigation'),_c('main-toolbar'),_c('main-content',{ref:"content"}),_c('g-snotify')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }